import React from 'react';
import { useAppContext } from './../components/Context';

//import tags
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

import { GoogleMap, MarkerF, useJsApiLoader } from '@react-google-maps/api';

//import resources
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

//import translation
import { useTranslation } from "react-i18next";
import "../i18n";

const containerStyle = {
    width: '100%',
    height: '450px'
};

const center = {
    lat: 41.7151,
    lng: 44.8271
};


function Contact({locale}) {


    const { globalContact } = useAppContext();
    const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
    const hasGoogleMapsApiKey = googleMapsApiKey.trim().length > 0;

    //get locale
    const { t } = useTranslation();

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey
    })

    const [map, setMap] = React.useState(null)

    const onLoad = React.useCallback(function callback(map) {
        const bounds = new window.google.maps.LatLngBounds(center);
        map.fitBounds(bounds);

        setMap(map)
    }, [])

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])


    return (
        <div className='main'>

            <section className="breadcumbSection" id="sectionBreadCumb">
                <Container>
                    <Row>
                        <Col xxl={12}>
                            <div className="breadcumb">
                                <div className="breadcumbLeft">
                                    <h1>{t('contact')}</h1>
                                </div>
                                <div className="breadcumbRight">
                                    <ul>
                                        <li><Link to={`/${locale}`}>{t('home')}</Link></li>
                                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                                        <li>{t('contact')}</li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="contactSection">
                <Container>
                    <Row>

                        <Col xxl={8}>
                            <div className="contactLeft">
                                <h2>{t('contact_form')}</h2>
                                <p>{t('contact_form_text')}</p>
                                <div className="contactForm">
                                    <Row>
                                        <Col xxl={6}>
                                            <div className="contactFormGroup">
                                                <label>{t('fname')}, {t('lname')}</label>
                                                <input type="text" name="name" placeholder={`${t('fname')}, ${t('lname')}`} />
                                            </div>
                                        </Col>
                                        <Col xxl={6}>
                                            <div className="contactFormGroup">
                                                <label>{t('email')}</label>
                                                <input type="email" name="email" placeholder={t('email')} />
                                            </div>
                                        </Col>
                                        <Col xxl={6}>
                                            <div className="contactFormGroup">
                                                <label>{t('phone')}</label>
                                                <input type="text" name="phone" placeholder={t('phone')} />
                                            </div>
                                        </Col>
                                        <Col xxl={6}>
                                            <div className="contactFormGroup">
                                                <label>{t('subject')}</label>
                                                <input type="text" name="subject" placeholder={t('subject')} />
                                            </div>
                                        </Col>
                                        <Col xxl={12}>
                                            <div className="contactFormGroup">
                                                <label>{t('message')}</label>
                                                <textarea name="message" placeholder={t('your_message')}></textarea>
                                            </div>
                                        </Col>
                                        <Col xxl={12}>
                                            <div className="contactFormGroup">
                                                <button className="sendRequest">{t('send_message')}</button>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>

                        <Col xxl={4}>
                            <div className="contactRight">
                                <h2>{t('contact_info')}</h2>
                                <p>{t('contact_info_text')}</p>
                                <div className="contactSingleBox">
                                    <h3>{t('address')}</h3>
                                    <Link to="/">{ typeof globalContact == 'object' ? globalContact?.translations[0].address : '' }</Link>
                                </div>
                                <div className="contactSingleBox">
                                    <h3>{t('phone')}</h3>
                                    <Link to="/">{ typeof globalContact == 'object' ? globalContact?.phone : '' }</Link><br />
                                    <Link to="/">{ typeof globalContact == 'object' ? globalContact?.phone2 : '' }</Link>
                                </div>
                                <div className="contactSingleBox">
                                    <h3>{t('email')}</h3>
                                    <Link to="/">{ typeof globalContact == 'object' ? globalContact?.email : '' }</Link>
                                </div>
                                <div className="contactSingleBox">
                                    <h3>{t('id_number')}</h3>
                                    <Link>{ typeof globalContact == 'object' ? globalContact?.idnum : '' }</Link><br />
                                </div>
                            </div>
                        </Col>

                        <Col xxl={12}>
                            <div className="map">
                                {hasGoogleMapsApiKey && isLoaded ? (
                                    <GoogleMap
                                        mapContainerStyle={containerStyle}
                                        center={center}
                                        zoom={18}
                                        onLoad={onLoad}
                                        onUnmount={onUnmount}
                                    >
                                        <MarkerF position={center} />
                                    </GoogleMap>
                                ) : (
                                    <iframe
                                        title="relux-location-map"
                                        width="100%"
                                        height="450"
                                        style={{ border: 0 }}
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        src="https://maps.google.com/maps?q=41.725910,44.746176&z=18&output=embed"
                                    />
                                )}
                            </div>
                        </Col>

                    </Row>
                </Container>
            </section>
        </div>
    )

}

export default Contact;